import { useRequest } from "../../../hooks/useRequest";
import useHttpResponseAlert from "../../../hooks/useHttpResponseAlert";
import routes from "../../../routes";

function useHubspotLink(userId: string) {
  const { fetch, response, error, loading } = useRequest();

  const { alert, setAlert } = useHttpResponseAlert(
    error,
    response,
    "User successfully linked to Hubspot!",
  );

  const link = () => {
    fetch("PUT", routes.api.user.hubspotLink({ userId }));
  };

  return {
    link,
    loading,
    url: response?.data.hubspotUrl,
    alert,
    setAlert,
  };
}

export default useHubspotLink;
